import { render, staticRenderFns } from "./TenantGoogleCalendarAuthEdit.vue?vue&type=template&id=cb007ff8&scoped=true"
import script from "./TenantGoogleCalendarAuthEdit.vue?vue&type=script&lang=js"
export * from "./TenantGoogleCalendarAuthEdit.vue?vue&type=script&lang=js"
import style0 from "./TenantGoogleCalendarAuthEdit.vue?vue&type=style&index=0&id=cb007ff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb007ff8",
  null
  
)

export default component.exports